<template>
  <div>
    <el-input
        class="search-el"
        size="mini"
        v-model="query.keyword"
        clearable
        placeholder="请输入商品名称"
    ></el-input>

    <el-select
        class="search-el"
        size="mini"
        v-model="query.status"
        placeholder="评价状态"
        clearable
        filterable
    >
      <el-option label="商品状态" value=""></el-option>
      <el-option label="上架" value="1"></el-option>
      <el-option label="下架" value="0"></el-option>
    </el-select>

    <el-select
        class="search-el"
        size="mini"
        v-model="query.show_status"
        placeholder="评价状态"
        clearable
        filterable
    >
      <el-option label="评价状态" value=""></el-option>
      <el-option label="显示" value="1"></el-option>
      <el-option label="隐藏" value="0"></el-option>
    </el-select>

    <el-input
        class="search-el"
        size="mini"
        v-model="query.start_score"
        clearable
        placeholder="起始分数"
    ></el-input>

    <el-input
        class="search-el"
        size="mini"
        v-model="query.end_score"
        clearable
        placeholder="终止分数"
    ></el-input>

    <el-button type="primary" size="mini" @click="getList()"> 查询</el-button>

    <el-row>
      <el-table
          v-loading="loading"
          :data="list"
          border
          size="mini"
          :stripe="true"
          style="width: 100%; margin: 20px 0;"
      >
        <el-table-column
            prop="pro_id"
            label="商品ID"
            align="center"
            min-width="5%"
        ></el-table-column>

        <el-table-column
            prop="status"
            label="商品状态"
            align="center"
            min-width="5%"
        ></el-table-column>

        <el-table-column
            prop="product_title"
            label="商品信息"
            align="center"
            min-width="10%"
        ></el-table-column>

        <el-table-column
            prop="order_no"
            label="对应订单号"
            align="center"
            min-width="8%"
        ></el-table-column>

        <el-table-column
            prop="paid_at"
            label="下单时间"
            align="center"
            min-width="7%"
        ></el-table-column>

        <el-table-column
            prop="user_info"
            label="下单用户信息"
            align="center"
            min-width="10%"
        ></el-table-column>

        <el-table-column
            prop="pj_at"
            label="评价时间"
            align="center"
            min-width="7%"
        ></el-table-column>

        <el-table-column
            prop="score"
            label="评分"
            align="center"
            min-width="5%"
        ></el-table-column>

        <el-table-column
            prop="content"
            label="内容"
            align="center"
            min-width="30%"
        ></el-table-column>

        <el-table-column
            prop="show_status_value"
            label="评价状态"
            align="center"
            min-width="5%"
        ></el-table-column>

        <el-table-column label="操作" align="center" min-width="7%">
          <template slot-scope="{ row }">
            <el-button v-if="row.show_status == 1"
                       type="text"
                       size="small"
                       @click="setStatus(row.id, 0)"
            >隐藏
            </el-button>
            <el-button v-if="row.show_status == 0"
                       type="text"
                       size="small"
                       @click="setStatus(row.id, 1)"
            >显示
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
            background
            @current-change="getList"
            :current-page.sync="query.page"
            :page-size="query.limit"
            layout="total, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import {getCommentList, updateCommentStatus} from "@/api/productComment";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        keyword: "",
        status: "",
        show_status: "",
        start_score: "",
        end_score: "",
        page: 1,
        limit: 20,
      },
      sid: 0,
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      getCommentList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    setStatus(id, value) {
      // eslint-disable-next-line no-unused-vars
      var msg_val = ''
      if (value == 1) {
        msg_val = '显示'
      } else {
        msg_val = '隐藏'
      }
      this.$confirm("此操作将该对象" + msg_val + ", 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        updateCommentStatus({
          id: id,
          show_status: value,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "设置成功",
              type: "success",
            });
            // eslint-disable-next-line no-empty
          } else {
          }
        });
      });
    },
  },
  mounted() {
  },
};
</script>
